import type { PlayersTabResponse } from '../../types';

export function isPlayersTabEmpty(data: PlayersTabResponse): boolean {
  const sideHasNoRows = (side: PlayersTabResponse['home']) =>
    side.goals.length === 0 &&
    side.assists.length === 0 &&
    side.shots.length === 0 &&
    side.cards.length === 0 &&
    side.injuries.length === 0;

  return sideHasNoRows(data.home) && sideHasNoRows(data.away);
}
